// External imports
import axios, { AxiosRequestConfig } from "axios";

// Internal imports
import { apis } from "./API";

// Base headers used for all requests
const baseHeaders: Record<string, string> = {
  "Ocp-Apim-Subscription-Key": "78fcd93ec3314036bea9a98c1a4d13af",
  "Content-Type": "application/x-www-form-urlencoded",
};

// Create Axios config with token and optional extra headers
const getConfig = (
  token: string,
  extraHeaders: Record<string, any> = {}
): AxiosRequestConfig => ({
  headers: {
    ...baseHeaders,
    Authorization: token,
    ...extraHeaders,
  },
});

// Generic GET request helper
const get = async (url: string, token: string) => {
  const auth_token_formatted = String(token).toLowerCase().includes("bearer")
    ? token
    : `bearer ${token}`;
  const { data } = await axios.get(url, getConfig(auth_token_formatted));
  return data;
};

// Generic POST request helper
const post = async (
  url: string,
  token: string,
  body: any,
  extraHeaders: Record<string, any> = {}
) => {
  const auth_token_formatted = String(token).toLowerCase().includes("bearer")
    ? token
    : `bearer ${token}`;
  const { data } = await axios.post(
    url,
    body,
    getConfig(auth_token_formatted, extraHeaders)
  );
  return data;
};

// -----------------------------
// API Endpoints
// -----------------------------

// Get user agreements
export const get_user_agreements = async (
  token: string,
  store_id: string,
  user_id: string
) => {
  const url = apis.get_user_agreements.url
    .replace("{StoreId}", store_id)
    .replace("{UserId}", user_id);
  return get(url, token);
};

// Get package by ID
export const get_package = async (
  token: string,
  club_id: string,
  package_id: string
) => {
  const url = apis.get_package.url
    .replace("{ClubId}", club_id)
    .replace("{PackageId}", package_id);
  return get(url, token);
};

// Cancel agreement
export const cancel_agreement = async (
  token: string,
  agreement_id: string,
  date: Date,
  note = "",
  enforceTerm = false,
  CancelledById: number
) => {
  const encodedId = encodeURIComponent(agreement_id);
  const encodedNote = encodeURIComponent(note);

  const url = apis.cancel_agreement_on_future_date.url
    .replace("{AgreementId}", encodedId)
    .replace("{CancellationDate}", encodeURIComponent(date.toISOString()))
    .replace("{CancelNote}", encodedNote)
    .replace("{CancelledById}", CancelledById);

  return post(url, token, {}, { EnforceTerm: String(enforceTerm) });
};

// Get user by ID
export const get_user_by_id = async (token: string, user_id: string) => {
  const url = apis.get_user_by_id.url.replace("{UserId}", user_id);
  return get(url, token);
};

// Login user by email
export const login = async (token: string, club_id: string, email: string) => {
  const url = apis.click_to_cancel_login.url.replace("{clubId}", club_id);
  return post(
    url,
    token,
    JSON.stringify({ email }), // Send raw JSON string
    { "Content-Type": "application/json" } // Override header
  );
};

// Get club by ID
export const get_club = async (token: string, club_id: string) => {
  const url = apis.get_club.url.replace("{clubId}", club_id);
  return get(url, token);
};